import { useTranslation } from 'react-i18next';
import { LuArrowDownUp } from 'react-icons/lu';

export function sortOptions(vacation = false, category = '') {
  const options = ['recent', 'price_asc', 'price_desc'];
  if (!vacation) options.push('price_m2_asc', 'price_m2_desc', 'surface_asc', 'surface_desc');
  if (!vacation && String(category).trim().toLowerCase() !== 'terrain') options.push('bedrooms_asc', 'bedrooms_desc');
  return options;
}
export function normalizeSort(value, vacation = false, category = '') {
  return sortOptions(vacation, category).includes(value) ? value : 'recent';
}
export default function ListingSort({ value, onChange, vacation = false, category = '' }) {
  const { t } = useTranslation();
  return <label className="my-4 flex max-w-full flex-wrap items-center gap-2 text-sm font-semibold text-slate-700">
    <LuArrowDownUp aria-hidden="true" size={18} />
    <span>{t('listingSort.label')}</span>
    <select className="min-w-0 max-w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5"
      value={normalizeSort(value, vacation, category)} onChange={event => onChange(event.target.value)}>
      {sortOptions(vacation, category).map(key => <option key={key} value={key}>{t('listingSort.' + (vacation && key.startsWith('price_') ? 'night_' + key : key))}</option>)}
    </select>
  </label>;
}
